// src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import { setAuthToken, refreshToken, signOut } from '../utils/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
          const newToken = await refreshToken();
          setAuthToken(newToken);
          setUser(storedUser);
        } else {
          logout();
        }
      } catch (_) {
        logout();
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    setAuthToken(token);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = async () => {
    try {
      await signOut();
    } catch (_) {
      // best-effort
    }
    setUser(null);
    setAuthToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const updateUser = (updatedUserData) => {
    setUser(updatedUserData);
    localStorage.setItem('user', JSON.stringify(updatedUserData));
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, authLoading: authLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
